<span>{{prefixValue}}{{badgeValue}}</span>
